import { Spacing, Typography } from "@p0security/ui";
import React, { ReactNode } from "react";

import "./Heading.less";

type HeadingProps = {
  cta?: ReactNode;
  title: ReactNode;
};

export const Heading: React.FC<HeadingProps> = ({ cta, title }) => (
  <Spacing mb={25}>
    <div className="md:flex md:items-center md:justify-between md:[&_h1]:mb-0!">
      <Typography.Title
        level={1}
        /* eslint-disable-line react/forbid-component-props */ style={{
          fontSize: "24px",
          textTransform: "capitalize",
        }}
      >
        {title}
      </Typography.Title>
      {cta}
    </div>
  </Spacing>
);
